import React from 'react';
import ReactDOM from 'react-dom';
import { isNil } from 'lodash';
import common from './common/common';
import renderComponents from './common/renderComponents';
import deferredImagesLoader from './deferredImagesLoader';
import { initTracing } from './tracing';
import serviceWorkerManager from './serviceWorkers/serviceWorkerManager.js';
import ProductSlider from '../src/components/modules/products/ProductSlider.jsx';
import Countdown from './components/Countdown.jsx';

initTracing();
serviceWorkerManager.registerMainServiceWorkers();

document.addEventListener(
    'DOMContentLoaded',
    function () {
        deferredImagesLoader.observeArticleImages();
        deferredImagesLoader.observeBannerImages();
        // Per pagina "Tutte le recensioni"
        // deferredImagesLoader.observeReviewGallery();
        // Per pagina "Tutte le domande"
        // deferredImagesLoader.observeQuestionGallery();
    },
    { passive: true }
);

console.log(`Running ${common.getSite()} for environment ${NODE_ENV}`);
window.renderComponents = renderComponents;
window.renderComponents();
window.checkProductsInViewport = () => {
    deferredImagesLoader.observeArticleImages();
};

const renderProductCarousel = () => {
    const el = document.querySelector('.noResults-products-carousel');
    if (!isNil(el)) {
        ReactDOM.render(
            <ProductSlider products={JSON.parse(el.dataset.products)} />,
            el
        );
    }
};
window.renderProductCarousel = renderProductCarousel;

const renderBannerCountdown = () => {
    const el = document.querySelector('.banner-countdown-container');
    if (!isNil(el)) {
        ReactDOM.render(
            <Countdown
                countdownDate={el.dataset.countdown}
                text={el.dataset.text}
            />,
            el
        );
    }
};
window.renderBannerCountdown = renderBannerCountdown;
